export const ReceiptTypeCodes = {
  Delivery: 'delivery',
  Pickup: 'pickup',
} as const;

export type ReceiptTypeCodes = (typeof ReceiptTypeCodes)[keyof typeof ReceiptTypeCodes];
